class BhAccordion extends HTMLElement {
  connectedCallback() {
    this.triggers = [...this.querySelectorAll('.accordion-trigger')];

    for (const trigger of this.triggers) {
      trigger.addEventListener('click', () => this.toggle(trigger));
    }
  }

  toggle(trigger) {
    const expanded = trigger.getAttribute('aria-expanded') === 'true';

    // Only one item open at a time, matching the original accordion.
    for (const other of this.triggers) {
      other.setAttribute('aria-expanded', 'false');
      document.getElementById(other.getAttribute('aria-controls')).hidden = true;
    }

    if (!expanded) {
      trigger.setAttribute('aria-expanded', 'true');
      document.getElementById(trigger.getAttribute('aria-controls')).hidden = false;
    }
  }
}

customElements.define('bh-accordion', BhAccordion);
